import { render, staticRenderFns } from "./CredentialForm.vue?vue&type=template&id=4bc4ca1a&"
import script from "./CredentialForm.vue?vue&type=script&lang=js&"
export * from "./CredentialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports